module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_24.396cc0b8.pdf";